import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FoodcourtService } from 'src/app/services/foodcourt.service';

@Component({
  standalone: false,
  selector: 'app-remove-modal-food-court',
  templateUrl: './remove-modal-food-court.component.html',
  styleUrls: ['./remove-modal-food-court.component.scss'],
})
export class RemovemodalfoodcourtComponent implements OnInit {
  @Input() couponId: string;
  @Input() fromDetailsPage: any;
  @Input() fromListPage: any;
  @Input() foodCourtId: any;

  listCouponIds = [];

  myForm!: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private foodcourtService: FoodcourtService
  ) {
    this.myForm = this.formBuilder.group({
      deletedBy: '',
      userId: ''
    });
  }

  ngOnInit(): void { }

  deleteFoodCourtData() {
    this.listCouponIds = [];
    if (this.fromDetailsPage == 'yes') {
      this.foodcourtService
        .removeBulkFoodCourt(this.foodCourtId)
        .subscribe((res) => {
          console.log(res);
          if (res.isValid) {
            this.router.navigate(['/list-food-court/']);
          }
        });
    }
    if (this.fromDetailsPage == 'no') {
      this.foodcourtService
        .removeBulkFoodCourt(this.foodCourtId)
        .subscribe((res) => {
          console.log(res);
          if (res.isValid) {
            location.reload();
          }
        });
    }
    this.modal.dismiss();
  }
}
